export class NewsletterUnsubscribeConfirmation {
  public static readonly type = '[Newsletter Unsubscribe] Unsubscribe Confirmation';
  constructor(public payload: string) {}
}

export class NewsletterUnsubscribeInitialState {
  public static readonly type = '[Newsletter Unsubscribe] Set Initial State';
}
